var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGuidePro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8l4.763 8.25H1.237L6 8zM17.1 8l4.763 8.25h-9.526L17.1 8zM11.55 12.5L6.137 3.125h10.826L11.55 12.5z",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMoneyGuidePro;